<template>
  <div class="mt-2">
    <!-- <div :style="[!noInnerWidth ? { width: width } : {}]"> -->
    <div class="table-wrapper">
      <b-table
        :busy="isLoading"
        head-variant="light"
        :no-local-sorting="true"
        :items="items"
        :fields="fields"
        per-page="0"
        :sticky-header="height"
        no-border-collapse
        responsive
        show-empty
        empty-text="Non ci sono informazioni da mostrare"
        small
      >
        <template #table-busy>
          <table-skeleton />
        </template>
        <template #empty>
          <template v-if="newImageBtn">
            <div
              class="d-flex flex-column justify-content-center align-items-center my-3"
              style="max-width: max-content; margin-inline: auto"
            >
              <p class="mb-2">
                Effettua una ricerca oppure, se non trovi risultati, crea una
                nuova Immagine cliccando sul pulsante qui sotto
              </p>
              <b-button
                class="btn-create px-3"
                type="button"
                variant="primary"
                size="sm"
                @click="onAddNewImage"
                title="Crea"
                :disabled="!canVerb(resource, 'store')"
                style="max-width: max-content"
              >
                <b-icon icon="plus-circle" aria-hidden="true"></b-icon>
                Crea
              </b-button
              >
            </div>
          </template>
          <template v-else>
            <empty-table
              :isTableInModal="isTableInModal"
              :performedSearch="performedSearch"
              :automaticPerformedSearch="automaticPerformedSearch"
              :filterCount="filterCount"
            />
          </template
          >
        </template>
        <template #cell(image)="row">
          <b-img
            class="image"
            :id="`image_${row.item.id}`"
            style="object-fit: contain"
            center
            thumbnail
            :src="getImage(row.item.id)"
            :alt="row.item.title"
          ></b-img>
        </template>

        <template #cell(actions)="row">
          <div class="action-buttons">
            <!-- <b-button
                size="sm"
                variant="lisaweb"
                @click="onEdit(row.item.id)"
                class="mt-1 mr-1"
                title="Modifica"
              >
                <base-icon name="edit" width="22"></base-icon>
              </b-button> -->
            <b-button
              size="sm"
              variant="lisaweb"
              @click="onDestroy(row.item.id)"
              class="mt-1 mr-1"
              title="Elimina"
            >
              <base-icon name="trash"></base-icon>
            </b-button>
          </div>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import template_lisaweb from "./template_lisaweb";
import BaseIcon from "@/components/BaseIcon";
import LisaComunicaMixin from "@/mixins/LisaComunicaMixin";
import EmptyTable from "@/components/EmptyTable.vue";

export default {
  name: "ImagesTable",
  components: {BaseIcon, EmptyTable},
  extends: template_lisaweb,
  mixins: [LisaComunicaMixin],
  props: {
    performedSearch: {
      type: Boolean,
      default: false,
    },
    filterCount: {
      type: Number,
      default() {
        return 0;
      },
    },
    isTableInModal: {
      type: Boolean,
      default: false,
    },
    saveRelationBtn: {
      type: Boolean,
      default: false,
    },
    hasChecksPaginated: {
      type: Boolean,
      default: false,
    },
    newImageBtn: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    formatItemsFrom() {
      if (!this.totalItems) return "";
      return this.items_from.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatItemsTo() {
      if (!this.totalItems) return "";
      return this.items_to.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatTotalItems() {
      if (!this.totalItems) return "";
      return this.totalItems.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
  methods: {
    freeSearch() {
      this.$emit("manualFetch");
    },
    onAddNewImage() {
      this.$router.push({
        name: `${this.resource}.create`,
        params: {
          /* remove the / character if it is the first character of a string */
          returnUrl: this.$route.path.replace(/^\/(.*)/, "$1"),
        },
      });
    },
    data() {
      return {
        isLoadedImage: false,
      };
    },
    getImage(id) {
      this.stream(id)
        .then((response) => {
          const blob = new Blob([response.data], {type: response.data.type});
          const blobUrl = URL.createObjectURL(blob);
          document.querySelector(`#image_${id}`).src = blobUrl;
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        });
    },
  },
};
</script>

<style scoped>
.image {
  display: block;
  max-width: 350px;
  max-height: 350px;
  width: auto;
  height: auto;
}
</style>
